import { personalTimeSheet, timeSheet } from "@planzone/dto";
import { Selector, State } from "./types";
import { matchRequest } from "./utils";

function createSelector(getState: () => State): Selector {
  return {
    isRetrievePersonalTimeSheetRequestFailure(resource, filter, size) {
      const req = getState().find((req) =>
        matchRequest(req, resource, filter, size),
      );

      return req ? req.request.isFailure : false;
    },
    isRetrievePersonalTimeSheetRequestPending(resource, filter, size) {
      const req = getState().find((req) =>
        matchRequest(req, resource, filter, size),
      );

      return req ? req.request.isPending : false;
    },
    isRetrievePersonalTimeSheetRequestSuccess(resource, filter, size) {
      const req = getState().find((req) =>
        matchRequest(req, resource, filter, size),
      );

      return req ? req.request.isSuccessful : false;
    },
    isResourceTimeSheetDirty(resource, filter, size) {
      const req = getState().find((req) =>
        matchRequest(req, resource, filter, size),
      );

      return req ? req.isDirty : false;
    },
    getPersonalTimeSheet(resource, filter, size) {
      const req = getState().find((req) =>
        matchRequest(req, resource, filter, size),
      );

      return req ? req.timeSheet : personalTimeSheet;
    },
    getPersonalTimeSheetCurrentPage(resource, filter, size) {
      const req = getState().find((req) =>
        matchRequest(req, resource, filter, size),
      );

      return req ? req.currentPage : 0;
    },
    canLoadMorePersonalTimeSheet(resource, filter, size) {
      const req = getState().find((req) =>
        matchRequest(req, resource, filter, size),
      );

      return req ? req.canLoadMore : true;
    },
  };
}

export { createSelector };
